import React from 'react';
import './QuemSomos.css';

const QuemSomos: React.FC = () => {
  return (
    <section id="quem-somos" className="quem-somos">
      <div className="container">
        <h2 className="section-title">Quem Somos</h2>
        <div className="quem-somos-content">
          <div className="about-text">
            <p className="section-subtitle">
              Na Garcias Milho, somos apaixonados por qualidade e sabor. Produzimos e
              distribuímos milho premium selecionado, ideal para supermercados,
              açougues, sacolões, bares, restaurantes, clubes e muito mais.
            </p>
            <div className="about-details">
              <div className="detail">
                <h3>Nossa Missão</h3>
                <p>
                  Nosso compromisso é com a excelência, buscando sempre superar as 
                  expectativas dos nossos clientes e parceiros, oferecendo milho de 
                  alta qualidade com sabor autêntico.
                </p>
              </div>
              <div className="detail">
                <h3>Nossos Valores</h3>
                <p>
                  Trabalhamos com milho premium de alta qualidade, garantindo frescor e 
                  sabor em cada grão. Nossa seleção é cuidadosamente processada para 
                  manter suas propriedades nutricionais e seu delicioso sabor.
                </p>
              </div>
              <div className="detail">
                <h3>Experiência</h3>
                <p>
                  Com anos de experiência no mercado, entendemos as necessidades dos 
                  nossos clientes e oferecemos produtos que atendem aos mais altos 
                  padrões de qualidade e segurança alimentar.
                </p>
              </div>
            </div>
          </div>
          <div className="about-stats">
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Qualidade</div>
            </div>
            <div className="stat">
              <div className="stat-number">24h</div>
              <div className="stat-label">Atendimento</div>
            </div>
            <div className="stat">
              <div className="stat-number">+500</div>
              <div className="stat-label">Clientes</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuemSomos;
